import { createRouter, createWebHistory } from 'vue-router'
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), 
  routes: [
    {
      path: '/',
      redirect: '/jsjy',
      component: () => import("@/views/homePage") ,
      children: [
      {
          path: '/jsjy',
          name: "index",
          component:   () => import("@/views/home/homeIndex.vue") ,
        },
        {
          path: '/list',
          name: "list",
          component:   () => import("@/views/home/homeList.vue") ,
        },
        {
          path: '/build',
          name: "build",
          component:   () => import("@/views/home/buildList.vue") ,
        },
        {
          path: '/detail',
          name: "detail",
          component:   () => import("@/views/home/infoDetail.vue") ,
        },
        {
          path: '/info',
          name: "info",
          component:   () => import("@/views/home/pageInfo.vue") ,
        },
      ]
    },
   {
      path: '/errorPage',
      name: 'errorPage',
      component: () => import("@/views/errorPage"),
      meta: {
        bread: "errorPage",
      }
    }
  ]
})

// router.beforeEach(async (to, from, next) => {
//   if (!localStorage.getItem("admin_token") && to.path != '/zyzjmanagement') {
//     window.location.href =  process.env.VUE_APP_LOGIN_URL 
//     return
//   }
//   if (to.query.jwt != undefined) {
//     localStorage.setItem('admin_token',to.query.jwt)
//     console.log('jwt存在')
//   }
//   next();
// });

export default router